import Vue from "vue";
import Vuex from "vuex";
import { actions } from "./actions.js";
import { mutations } from "./mutations.js";
import { getters } from "./getters.js";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    profile: null,
    IsAuthenticated: false,
    artists: [],
    featured_artists: [],
    artists_count: 0,
    art: null,
    explore_art: [],
    artistProfile: null,
    artistProducts: [],
    wishList: [],
    navigateBackTo: {
      required: false,
      url: "",
      metaInfo: {},
    },
    homePageContent: null,
    art_stories_list: [],
    art_story: null,
    featured_art_stories_list: [],
    exhibition_list: [],
    cart_list: [],
    address_list: [],
    order_list: null,
  },
  mutations: mutations,
  actions: actions,
  getters: getters,
});
